/* eslint-disable no-unused-vars */

export enum taskConstant {
  GET_TASKS = 'GET_TASKS',
  UPDATE_TASKS = 'UPDATE_TASKS',
  UPDATE_STATUS_TASK = 'UPDATE_STATUS_TASK',
  UPDATE_CURRENT_QUESTION_TASK = 'UPDATE_CURRENT_QUESTION_TASK',
  UPDATE_CURRENT_TASK = 'UPDATE_CURRENT_TASK',
  UPDATE_PROCESS_TASK_ID = 'UPDATE_PROCESS_TASK_ID',
  UPDATE_TEMPORARY_TASK_ID = 'UPDATE_TEMPORARY_TASK_ID',
  UPDATE_CURRENT_TASK_DATA = 'UPDATE_CURRENT_TASK_DATA',
  CLEAR_CURRENT_TASK_SELECTED_FILES = 'CLEAR_CURRENT_TASK_SELECTED_FILES',
  CLEAR_TEMPORARY_TASK = 'CLEAR_TEMPORARY_TASK',
  LOAD_TEMPORARY_TASK_DATA = 'LOAD_TEMPORARY_TASK_DATA',
  GET_LATEST_TASK = 'GET_LATEST_TASK',
  GET_DETAIL_TASK = 'GET_DETAIL_TASK',
  EDIT_TASK_NAME = 'EDIT_TASK_NAME',
  ADD_NEW_QUESTION_TASK = 'ADD_NEW_QUESTION_TASK',
  ADD_NEW_TASK = 'ADD_NEW_TASK',
  UPDATE_NEW_ANSWER_TASK = 'UPDATE_NEW_ANSWER_TASK',
  DELETE_TASK = 'DELETE_TASK',
  UPDATE_NEW_QUESTION_TASK = 'UPDATE_NEW_QUESTION_TASK',
  UPDATE_LIMIT_STATUS_TASK = 'UPDATE_LIMIT_STATUS_TASK',
  EDIT_QUESTION_TASK = 'EDIT_QUESTION_TASK',
  ADD_SELECTED_FILE = 'ADD_SELECTED_FILE',
  UPDATE_SELECTED_FILE = 'UPDATE_SELECTED_FILE',
  REMOVE_SELECTED_FILE = 'REMOVE_SELECTED_FILE',
  UPDATE_FILE_STATUS = 'UPDATE_FILE_STATUS',
  UPDATE_INITIAL_SELECTED_FILES = 'UPDATE_INITIAL_SELECTED_FILES',
  RESET_DATA = 'RESET_DATA',
  UPDATE_PROCESSING_STREAMING_CHUNK_STATUS_TASK = 'UPDATE_PROCESSING_STREAMING_CHUNK_STATUS_TASK',
  UPDATE_NEW_STREAMING_ANSWER_CHUNKS_TASK = 'UPDATE_NEW_STREAMING_ANSWER_CHUNKS_TASK',
  CLEAR_STREAMING_ANSWER_CHUNKS_TASK = 'CLEAR_STREAMING_ANSWER_CHUNKS_TASK',
  SET_TIMEOUT_FOR_FINAL_ANSWER_TASK = 'SET_TIMEOUT_FOR_FINAL_ANSWER_TASK',
}
